<template>
  <transition
    :enterActiveClass="$style.loadingOverlayEnterActive"
    :enterClass="$style.loadingOverlayEnter"
    :leaveActiveClass="$style.loadingOverlayLeaveActive"
    :leaveToClass="$style.loadingOverlayLeaveTo"
  >
    <div
      v-if="showLoadingOverlay"
      :class="$style.loadingOverlay"
      :style="{ zIndex }"
    >
      <LoadingIcon large />
      <span
        v-if="loadingOverlayText"
        :class="$style.loadingOverlayText"
      >
        {{ loadingOverlayText }}
      </span>
    </div>
  </transition>
</template>
<script>
import { loadingOverlayZIndex } from 'client/css/z-index.css';
import LoadingIcon from 'components/LoadingOverlay/LoadingIcon.vue';

export default {
  name: 'LoadingOverlay',

  components: {
    LoadingIcon,
  },

  props: {
    loadingOverlayText: {
      default: null,
      type: String,
    },
    showLoadingOverlay: {
      default: false,
      type: Boolean,
    },
    zIndex: {
      default: Number(loadingOverlayZIndex),
      type: Number,
    },
  },
};
</script>
<style scoped module>
@value (fadeTransition) from '~css/transitions.css';
@value (gradientLight2) from '~css/colors.css';

.loadingOverlay {
  align-items: center;
  background-color: gradientLight2;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  left: 0;
  opacity: 0.5;
  position: absolute;
  top: 0;
  width: 100%;
}

.loadingOverlayEnterActive {
  transition: opacity 250ms ease-in;
}

.loadingOverlayLeaveActive {
  transition: fadeTransition;
}

.loadingOverlayEnter,
.loadingOverlayLeaveTo {
  opacity: 0;
}

.loadingOverlayText {
  margin-top: 15px;
}
</style>
